import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'

export default function Error403() {
  return (
    <div className="flex flex-col min-h-[70vh] items-center justify-center px-4 text-center py-20 bg-white">
      <Helmet>
        <title>Adgang nægtet - 403 - Hansen og Mortensen</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <span className="text-red-700 text-6xl sm:text-8xl font-black tracking-widest mb-4">
        403
      </span>
      <h1 className="text-2xl sm:text-4xl font-black text-neutral-950 uppercase tracking-tight mb-4">
        Adgang nægtet
      </h1>
      <div className="w-16 h-1 bg-red-700 mb-6" />
      <p className="text-zinc-600 text-sm sm:text-base max-w-md leading-relaxed mb-10">
        Du har ikke tilladelse til at tilgå denne ressource eller side.
      </p>

      <Link
        to="/"
        className="bg-red-700 hover:bg-red-800 text-white text-xs font-bold uppercase tracking-widest px-8 py-4 transition-all duration-300"
      >
        Gå til forsiden <i className="fa-solid fa-house ml-2 text-[10px]" />
      </Link>
    </div>
  )
}
